"use strict";
/**
 * Exact aspect-ratio fit — the single rule deciding whether a video canvas can honestly target a
 * channel placement (there is no reframing in the video-editor flow, so "close" is not "fits").
 * Backend target validation, the payload's `fits` flag, and the web picker's filter all call this
 * one function so they can never disagree.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.aspectRatiosMatch = aspectRatiosMatch;
function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
}
/** True when the two dimension pairs reduce to the same integer ratio (1080×1920 ≡ 2160×3840). */
function aspectRatiosMatch(width1, height1, width2, height2) {
    if (![width1, height1, width2, height2].every((n) => Number.isInteger(n) && n > 0))
        return false;
    const divisor1 = gcd(width1, height1);
    const divisor2 = gcd(width2, height2);
    return width1 / divisor1 === width2 / divisor2 && height1 / divisor1 === height2 / divisor2;
}
